import { GetElementPositionProps } from '../analytics-context-types';
import { isSplitPanelFace } from '../../../utils/panel-zoom/is-split-panel-face';

export const getElementPosition = ({ paramsElement, object, face }: GetElementPositionProps): string => {
  const { cardState, initializedDataState, activeCardFace, canvas } = paramsElement ?? {};
  let cardSide: string | undefined;
  let cardHalfSize: number;
  const { cardFormat: format } = cardState || {};

  const isSignSend = initializedDataState?.data?.project_type_code === 'S';
  const cardFaceType = face || activeCardFace?.type;
  const activeObject = object ? object : canvas?.current?.getActiveObject();
  const canvasWidth = canvas?.current?.getWidth() ?? 0;
  const canvasHeight = canvas?.current?.getHeight() ?? 0;
  if (activeObject) {
    if (cardFaceType === 'front') {
      return 'outside-front';
    } else if (cardFaceType === 'back') {
      return 'outside-back';
    } else if (format === 'portrait' && isSplitPanelFace(cardFaceType)) {
      // Split-panel faces already carry their own side ('inside-left'/'inside-right') and each
      // has its own half-width canvas, so the left/right heuristic below would misread the side.
      // Landscape/vertical faces still fall through: their side is top/bottom, which the face
      // type does not encode, so the position math is still required there.
      return cardFaceType;
    } else if (format === 'portrait' && !isSignSend) {
      cardHalfSize = canvasWidth / 2;
      cardSide = (activeObject.left as number) >= cardHalfSize ? 'right' : 'left';
    } else if (format === 'landscape' || format === 'vertical') {
      cardHalfSize = canvasHeight / 2;
      cardSide = (activeObject.top as number) >= cardHalfSize ? 'bottom' : 'top';
    }
    return `${cardFaceType}${cardSide ? `-${cardSide}` : ''}`;
  }
  return cardFaceType || '';
};
